import { CompanySizeOption } from './CompanySizeOption';
import { CompanySizeNumber } from './CompanySizeNumber';
export const CompanySizeNumberAndLabels = {
  [CompanySizeOption.One]: {
    companySizeNumber: CompanySizeNumber.One,
    companySizeLabel: '1'
  },
  [CompanySizeOption.TwoToFive]: {
    companySizeNumber: CompanySizeNumber.TwoToFive,
    companySizeLabel: '2 to 5'
  },
  [CompanySizeOption.SixToTen]: {
    companySizeNumber: CompanySizeNumber.SixToTen,
    companySizeLabel: '6 to 10'
  },
  [CompanySizeOption.ElevenToTwentyFive]: {
    companySizeNumber: CompanySizeNumber.ElevenToTwentyFive,
    companySizeLabel: '11 to 25'
  },
  [CompanySizeOption.TwentySixToFifty]: {
    companySizeNumber: CompanySizeNumber.TwentySixToFifty,
    companySizeLabel: '26 to 50'
  },
  [CompanySizeOption.FiftyOneToTwoHundred]: {
    companySizeNumber: CompanySizeNumber.FiftyOneToTwoHundred,
    companySizeLabel: '51 to 200'
  },
  [CompanySizeOption.TwoHundredOneToOneThousand]: {
    companySizeNumber: CompanySizeNumber.TwoHundredOneToOneThousand,
    companySizeLabel: '201 to 1,000'
  },
  [CompanySizeOption.OneThousandOnetoTenThousand]: {
    companySizeNumber: CompanySizeNumber.OneThousandOnetoTenThousand,
    companySizeLabel: '1,001 to 10,000'
  },
  [CompanySizeOption.TenThousandOneOrMore]: {
    companySizeNumber: CompanySizeNumber.TenThousandOneOrMore,
    companySizeLabel: '10,001 or more'
  }
};